import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/accounts/$accountId")(
  {
    component: Outlet,
    loader: async (ctx) => {
      const accountId = parseInt(ctx.params.accountId);
      if (isNaN(accountId)) {
        throw notFound();
      }

      return { parsedAccountId: accountId };
    },
  },
);
